<template>
  <div>欢迎页</div>
</template>

<script>
export default {

}
</script>

<style>

</style>